import { render, staticRenderFns } from "./openclass.vue?vue&type=template&id=528746a5&scoped=true&"
import script from "./openclass.vue?vue&type=script&lang=js&"
export * from "./openclass.vue?vue&type=script&lang=js&"
import style0 from "./openclass.vue?vue&type=style&index=0&id=528746a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528746a5",
  null
  
)

export default component.exports